"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.reflect.get");

var _lodash = _interopRequireDefault(require("lodash"));

var _BaseEdit = _interopRequireDefault(require("../components/base/editForm/Base.edit.logic"));

var _utils = _interopRequireDefault(require("../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// Добавляет возможность выбрать сам компонент для 'trigger'
_BaseEdit.default[0].components[1].components[0].components[1].components[1].data.custom = "\n                        utils.eachComponent(instance.root.editForm.components, function(component, path) {\n                            values.push({\n                              label: component.label || component.key,\n                              value: path\n                            });\n                        });\n                      "; // Добавляет возможность выбрать компонент для 'action'

_BaseEdit.default[0].components[2].components[0].components.push({
  type: 'select',
  input: true,
  label: 'Component:',
  key: 'componentAction',
  dataSrc: 'custom',
  valueProperty: 'value',
  data: {
    custom: "\n                 utils.eachComponent(instance.root.editForm.components, function(component, path) {\n                     values.push({\n                       label: component.label || component.key,\n                       value: path\n                     });\n                 });\n                "
  }
}); // Исправление компонента, не работало 'value'


_BaseEdit.default[0].components[2].components[0].components[2] = {
  weight: 20,
  type: 'select',
  template: '<span>{{ item.label }}</span>',
  dataSrc: 'json',
  data: {
    json: [{
      label: 'Hidden',
      value: {
        value: 'hidden',
        type: 'boolean'
      }
    }, {
      label: 'Required',
      value: {
        value: 'validate.required',
        type: 'boolean'
      }
    }, {
      label: 'Disabled',
      value: {
        value: 'disabled',
        type: 'boolean'
      }
    }, {
      label: 'Label',
      value: {
        value: 'label',
        type: 'string'
      }
    }, {
      label: 'Title',
      value: {
        value: 'title',
        type: 'string'
      }
    }, {
      label: 'Tooltip',
      value: {
        value: 'tooltip',
        type: 'string'
      }
    }, {
      label: 'Description',
      value: {
        value: 'description',
        type: 'string'
      }
    }, {
      label: 'Placeholder',
      value: {
        value: 'placeholder',
        type: 'string'
      }
    }, {
      label: 'CSS Class',
      value: {
        value: 'className',
        type: 'string'
      }
    }, {
      label: 'Container Custom Class',
      value: {
        value: 'customClass',
        type: 'string'
      }
    }]
  },
  key: 'property',
  label: 'Component Property',
  input: true,
  customConditional: 'show = row.type === "property";'
};

var WithLogic = function WithLogic(_WithLogic2) {
  return (
    /*#__PURE__*/
    function (_WithLogic) {
      _inherits(_class, _WithLogic);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "applyActions",
        value: function applyActions(action, result, data, newComponent, actionComponent) {
          var changed = false;

          switch (action.type) {
            case 'property':
              _utils.default.setActionProperty(newComponent, action, this.data, data, newComponent, result, newComponent);

              break;

            case 'value':
              {
                var oldValue = actionComponent.getValue();
                var newValue = actionComponent.evaluate(action.value, {
                  value: _lodash.default.clone(oldValue),
                  data: data,
                  component: newComponent,
                  result: result
                }, 'value');

                if (!_lodash.default.isEqual(oldValue, newValue)) {
                  actionComponent.setValue(newValue);
                  changed = true;
                }

                break;
              }

            case 'validation':
              // TODO
              break;
          }

          return changed;
        }
      }, {
        key: "fieldLogic",
        value: function fieldLogic(data) {
          var _this = this;

          var logics = this.logic; // If there aren't logic, don't go further.

          if (!logics.length) {
            return;
          }

          var triggerComponentsKeys = [];
          var newComponentsStore = [];
          this.actionComponents = [];
          var changed = logics.reduce(function (changed, logic, logicIndex) {
            logic.actions.forEach(function (action, actionIndex) {
              if (!triggerComponentsKeys[logicIndex]) {
                triggerComponentsKeys[logicIndex] = [];
              }

              if (!_this.actionComponents[logicIndex]) {
                _this.actionComponents[logicIndex] = [];
              }

              if (!newComponentsStore[logicIndex]) {
                newComponentsStore[logicIndex] = [];
              }

              triggerComponentsKeys[logicIndex][actionIndex] = action.componentAction;
              var triggerComponentKey = action.componentAction;
              _this.actionComponents[logicIndex][actionIndex] = triggerComponentKey ? _this.getActionComponent(triggerComponentKey) : _this;
              var actionComponent = _this.actionComponents[logicIndex][actionIndex];
              newComponentsStore[logicIndex][actionIndex] = _lodash.default.cloneDeep(actionComponent.originalComponent);
              var newComponent = newComponentsStore[logicIndex][actionIndex];
              data = data || actionComponent.rootValue;

              var result = _utils.default.checkTrigger(newComponent, logic.trigger, actionComponent.data, data, actionComponent.root ? actionComponent.root._form : {}, actionComponent);

              if (result) {
                changed |= actionComponent.applyActions(action, result, data, newComponent, actionComponent);
              }

              return changed;
            });
          }, false);
          newComponentsStore.forEach(function (newComponentsList, listIndex) {
            newComponentsList.forEach(function (newComponent, componentIndex) {
              // If component definition changed, replace and mark as changed.
              if (!_lodash.default.isEqual(_this.actionComponents[listIndex][componentIndex].component, newComponent)) {
                var triggerComponentKey = triggerComponentsKeys[listIndex][componentIndex];

                if (triggerComponentKey) {
                  var actionComponent = _this.getActionComponent(triggerComponentKey);

                  actionComponent.component = newComponent;
                  _this.newActionComponent = actionComponent;
                } else {
                  _this.component = newComponent;
                  _this.newActionComponent = null;
                }

                changed = true;
              }
            });
          });
          return changed;
        }
      }, {
        key: "viewOnlyBuild",
        value: function viewOnlyBuild() {
          if (!this.element) {
            this.createViewOnlyElement();
          }

          this.createViewOnlyLabel(this.element);
          this.createViewOnlyValue(this.element);
        } // Find component by key

      }, {
        key: "getActionComponent",
        value: function getActionComponent(componentKey) {
          var actionComponent = this;
          var rootComponents = this.root.components;

          var findComponent = function findComponent(components) {
            components.forEach(function (component) {
              var nextComponents = component.components;

              if (nextComponents) {
                findComponent(nextComponents);
              }

              if (component.key === componentKey) {
                actionComponent = component;
              }
            });
          };

          findComponent(rootComponents);
          return actionComponent;
        }
      }, {
        key: "checkConditions",
        value: function checkConditions(data) {
          data = data || this.rootValue;

          if (!this.options.builder && this.fieldLogic(data)) {
            var component = this.newActionComponent ? this.newActionComponent : this;
            component.redraw();
            component.logicShow(this.conditionallyVisible(data));
            return;
          }

          return _get(_getPrototypeOf(_class.prototype), "checkConditions", this).call(this, data);
        }
      }, {
        key: "logicShow",
        value: function logicShow(show, noClear) {
          this.showElement(show && !this.component.hidden);
          return _get(_getPrototypeOf(_class.prototype), "show", this).call(this, show, noClear);
        }
      }]);

      return _class;
    }(_WithLogic2)
  );
};

var _default = WithLogic;
exports.default = _default;